export const API_RESPONSE = {
  STATUS: {
    SUCCESS: 1,
    FAILURE: -1,
  },
};

export const COMMON_DATABASE_VALUE = {
  FLAG: {
    ENABLED: '1',
    DISABLED: '0',
  },
  VALUE: {
    ENABLED: 'True',
    DISABLED: 'False',
  },
};

export const TOKEN = {
  TYPE: 'Bearer',
};

export const CONTENT_TYPE = {
  JSON: 'application/json',
};

export const COOKIES = {
  AUTH: '_auth',
};

export const ERROR_CODE = {
  PERMISSION_DENIED: 101,
  END_DAY_LOCK: 777,
  PERMISSION_DENIED_: -101,
  DEFAULT_ERROR: 0,
  SWAP_ROOM: {
    PRICE_LESS_THAN_STANDARD_PRICE: -1,
    EB_PRICE_LESS_THAN_STANDARD_EB_PRICE: -2,
    ALLOW_DOWN_RATE: {
      PRICE_LESS_THAN_STANDARD_PRICE: -3,
      EB_PRICE_LESS_THAN_STANDARD_EB_PRICE: -4,
    },
  },
  BOOKING: {
    REMOVE_BOOKING: {
      DEBT_ARISES: -1,
      DEPOSITED_NOTE_ARISES: -2,
      REGISTERED_ROOM: -3,
      ROOM_ASSIGNED: -4,
      DEPOSITED_BOOKING: -5,
    },
    GUEST_INFO: {
      ROOM_NOT_SELECTED: -1,
      ONLY_10_GUESTS: -2,
    },
    RECOVER_BOOKING: {
      ALL_ROOM_OVERBOOK: 102,
      ROOM_TYPE_OVERBOOK: 103,
      FAILED: 104,
      CANNOT_RECOVER_WITHOUT_CANCEL_NOSHOW: 105,
    },
  },
  CHECKOUT: {
    GUEST_CHECKOUT: {
      CHECK_BEFORE_GUEST_CHECKOUT_CHECKOUT_ROOM: 102,
      CHECK_BEFORE_GUEST_CHECKOUT_CHECKOUT_CHILD: 103,
      CHECK_BEFORE_GUEST_CHECKOUT_DEPOSITED_ROOM: 104,
      CHECK_BEFORE_GUEST_CHECKOUT_DEBT_ARISES: 105,
      CHECK_BEFORE_GUEST_CHECKOUT_HAVE_ADVANCE_PAYMENT: 106,
      CHECK_BEFORE_GUEST_CHECKOUT_PAY_DEBT: 107,
    },
    TRANSFER_BILL: {
      CAN_NOT_TRANSFER_BILL: 111,
      CAN_NOT_TRANSFER_DEPOSIT: 121,
    },
  },
  COMPANY: {
    CAN_NOT_DELETE_COMPANY: 102,
    HAS_COMPANY_USED_IN_BOOKING: 103,
  },
  ROOM_ASSIGNMENT: {
    CANT_SAVE_ROOM_SCHEDULE_CLEANERS: 102,
    CANT_DELETE_ROOM_SCHEDULE_CLEANERS: 103,
  },
  NIGHT_AUDIT: {
    CAN_NOT_LATE_CHECKIN_WITH_ARRIVAL_DATE_SAME_DEPARTURE_DATE: 102,
    CAN_NOT_LATE_CHECKIN_COMMON: 103,
    CAN_NOT_NO_SHOW_DEPOSIT_ROOM: 104,
    CAN_NOT_NO_SHOW_CHECKIN_ROOM: 105,
    CAN_NOT_NO_SHOW_BOOKING_ARISEN_AS_A_SERVICE: 106,
    CAN_NOT_NO_SHOW_BOOKING_ARISEN_ADVANCE_PAYMENT: 107,
    CAN_NOT_NO_SHOW_BOOKING_DEPOSITED: 108,
    CAN_NOT_NO_SHOW_BOOKING_ARISEN_AS_A_SERVICE_ASK: 109,
    CAN_NOT_NO_SHOW_BOOKING_ARISEN_ADVANCE_PAYMENT_ASK: 110,
    CAN_NOT_NO_SHOW_BOOKING_DEPOSITED_ASK: 111,
    CAN_NOT_NO_SHOW_COMMON: 112,
    CAN_NOT_EXTEND_DAYS_DAY_USE: 201,
    CAN_NOT_EXTEND_DAYS_LOCK_ROOM: 202,
    CAN_NOT_EXTEND_DAYS_ROOM_CONFIRM: 203,
    END_DAY_FB_BILL_NOT_PAID_YET: 666,
  },
  HOUSE_KEEPING_DEFINITION: {
    SAVE_PRODUCT_DATA_HK_DEFINITION_SUCCESS_BUT_HAVE_ERROR: 102,
    SAVE_PRODUCT_DATA_HK_DEFINITION_INVALID_UNIT: 103,
    SAVE_PRODUCT_DATA_HK_DEFINITION_INVALID_STANDARD_PRICE: 104,
    SAVE_PRODUCT_DATA_HK_DEFINITION_INVALID_PRODUCT_NAME: 105,
    SAVE_PRODUCT_DATA_HK_DEFINITION_NOT_EXIST_PRODUCT_KIND: 106,
    SAVE_PRODUCT_GROUP_DATA_HK_DEFINITION_NOT_EXIST_OUTLET: 107,
    SAVE_PRODUCT_GROUP_DATA_HK_DEFINITION_PRODUCT_KIND_NAME_EMPTY: 108,
    SAVE_PRODUCT_GROUP_DATA_HK_DEFINITION_UPDATE_FAILED: 109,
    SAVE_PRODUCT_GROUP_DATA_HK_DEFINITION_ADD_FAILED: 110,
    DELETE_PRODUCT_GROUP_DATA_HK_DEFINITION_PRODUCT_GROUP_ID_NOT_FOUND: 111,
    DELETE_PRODUCT_GROUP_DATA_HK_DEFINITION_PRODUCT_CAN_NOT_DELETE: 112,
    DELETE_PRODUCT_DATE_HK_DEFINITION_PRODUCT_IN_USED: 113,
    DELETE_PRODUCT_DATE_HK_DEFINITION_DELETE_FAILED: 114,
  },
  PAYMENT_MANAGEMENT: {
    DELETE_PAYMENT_METHOD: {
      PAYMENT_IN_USED: 102,
      DELETE_FAILED: 103,
    },
    DELETE_GROUP_PAYMENT_METHOD: {
      PAYMENT_IN_USED: 102,
      DELETE_FAILED: 103,
    },
  },
  SERVICE_MANAGEMENT: {
    DELETE_SERVICES: {
      SERVICE_IN_USED: 102,
      DELETE_FAILED: 103,
    },
    DELETE_GROUP_SERVICES: {
      SERVICE_IN_USED: 104,
      DELETE_FAILED: 105,
    },
  },
  CMS: {
    EXELY: {
      BOOKING: {
        CREATE_FAILED: 103,
      },
    },
  },
  RECAPTCHA: {
    RECAPTCHA_VERIFICATION_FAILED: 102,
    RECAPTCHA_LOW_SCORE: 103,
  },
};
